export const PRODUCTS = {
    IMAGOADMIN: 'imagoadmin',
};

export const ROUTES = {
    ROOT_PATH: '/',
    LOGIN: '/login',
    INSTANCES: '/instances',
    INSTANCE_DETAIL: '/instances/:id',
    USERS: '/users',
    SUPPORT_PACKAGES: '/support-packages',
};

export const LEGACY_TOKEN_TYPE = 'imago-legacy';
